import { isString, useStableCallback, useConstant, usePrevious, isFunction, isNumber, useForceUpdate, createNamedContext, noop as noop$1, isBoolean as isBoolean$1 } from '@reach/utils';
export { checkStyles, cloneValidElement, createNamedContext, getDocumentDimensions, isBoolean, isFunction, isNumber, isString, makeId, useCheckStyles, useComposedRefs, useConstant, useControlledState, useControlledSwitchWarning, useForceUpdate, useComposedRefs as useForkedRef, useIsomorphicLayoutEffect, usePrevious, useStableCallback, useUpdateEffect } from '@reach/utils';
import { __rest, __awaiter } from 'tslib';
import * as React from 'react';
import addImageIconUrl from './assets/add-image-icon.svg';
import amexIconUrl from './assets/amex-icon.svg';
import arrowLeftIconUrl from './assets/arrow-left-icon.svg';
import arrowRightInCircleIconUrl from './assets/arrow-right-in-circle-icon.svg';
import badgeIconUrl from './assets/badge-icon.svg';
import bankIconUrl from './assets/bank-icon.svg';
import bellIconUrl from './assets/bell-icon.svg';
import bigCheckIconUrl from './assets/big-check-icon.svg';
import bookIconUrl from './assets/book-icon.svg';
import boxIconUrl from './assets/box-icon.svg';
import brokenLinkIconUrl from './assets/broken-link-icon.svg';
import businessIconUrl from './assets/business-icon.svg';
import calendarIconUrl from './assets/calendar-icon.svg';
import cameraIconUrl from './assets/camera-icon.svg';
import cardIconUrl from './assets/card-icon.svg';
import cardsIconUrl from './assets/cards-icon.svg';
import cartIconUrl from './assets/cart-icon.svg';
import checkIconUrl from './assets/check-icon.svg';
import checkInCircleIconUrl from './assets/check-in-circle-icon.svg';
import checkInCircleOutlineIconUrl from './assets/check-in-circle-outline-icon.svg';
import checkedIconUrl from './assets/checked-icon.svg';
import chevronDoubleRightIconUrl from './assets/chevron-double-right-icon.svg';
import chevronDownIconUrl from './assets/chevron-down-icon.svg';
import chevronLeftIconUrl from './assets/chevron-left-icon.svg';
import chevronRightIconUrl from './assets/chevron-right-icon.svg';
import chevronUpIconUrl from './assets/chevron-up-icon.svg';
import circleIconUrl from './assets/circle-icon.svg';
import circleMinusIconUrl from './assets/circle-minus-icon.svg';
import clipboardIconUrl from './assets/clipboard-icon.svg';
import clockIconUrl from './assets/clock-icon.svg';
import cogIconUrl from './assets/cog-icon.svg';
import compassIconUrl from './assets/compass-icon.svg';
import contactBookIconUrl from './assets/contact-book-icon.svg';
import cookiesIconUrl from './assets/cookies-icon.svg';
import copyIconUrl from './assets/copy-icon.svg';
import creditCardIconUrl from './assets/credit-card-icon.svg';
import crossIconUrl from './assets/cross-icon.svg';
import crossInCircleIconUrl from './assets/cross-in-circle-icon.svg';
import desktopIconUrl from './assets/desktop-icon.svg';
import diamondIconUrl from './assets/diamond-icon.svg';
import docIconUrl from './assets/doc-icon.svg';
import documentIconUrl from './assets/document-icon.svg';
import dotHorizontalIconUrl from './assets/dot-horizontal-icon.svg';
import dotVerticalIconUrl from './assets/dot-vertical-icon.svg';
import downloadIconUrl from './assets/download-icon.svg';
import evChargingIconUrl from './assets/ev-charging-icon.svg';
import editIconUrl from './assets/edit-icon.svg';
import engineIconUrl from './assets/engine-icon.svg';
import errorIconUrl from './assets/error-icon.svg';
import exclamationIconUrl from './assets/exclamation-icon.svg';
import expandLessIconUrl from './assets/expand-less-icon.svg';
import expandMoreIconUrl from './assets/expand-more-icon.svg';
import externalIconUrl from './assets/external-icon.svg';
import eyeHideIconUrl from './assets/eye-hide-icon.svg';
import eyeShowIconUrl from './assets/eye-show-icon.svg';
import familyIconUrl from './assets/family-icon.svg';
import filledStarIconUrl from './assets/filled-star-icon.svg';
import filterIconUrl from './assets/filter-icon.svg';
import fuelTankIconUrl from './assets/fuel-tank-icon.svg';
import gasTankIconUrl from './assets/gas-tank-icon.svg';
import heartIconUrl from './assets/heart-icon.svg';
import helpIconUrl from './assets/help-icon.svg';
import historyIconUrl from './assets/history-icon.svg';
import imageIconUrl from './assets/image-icon.svg';
import inboxIconUrl from './assets/inbox-icon.svg';
import infoIconUrl from './assets/info-icon.svg';
import infoOutlineIconUrl from './assets/info-outline-icon.svg';
import inviteIconUrl from './assets/invite-icon.svg';
import languageIconUrl from './assets/language-icon.svg';
import lifebuoyIconUrl from './assets/lifebuoy-icon.svg';
import linkIconUrl from './assets/link-icon.svg';
import listIconUrl from './assets/list-icon.svg';
import locationIconUrl from './assets/location-icon.svg';
import lockIconUrl from './assets/lock-icon.svg';
import logoutIconUrl from './assets/logout-icon.svg';
import lorryIconUrl from './assets/lorry-icon.svg';
import loudspeakerIconUrl from './assets/loudspeaker-icon.svg';
import mailIconUrl from './assets/mail-icon.svg';
import malaysiaFlagIconUrl from './assets/malaysia-flag-icon.svg';
import mapIconUrl from './assets/map-icon.svg';
import mastercardIconUrl from './assets/mastercard-icon.svg';
import membershipIconUrl from './assets/membership-icon.svg';
import menuIconUrl from './assets/menu-icon.svg';
import merchantIconUrl from './assets/merchant-icon.svg';
import mesraCardIconUrl from './assets/mesra-card-icon.svg';
import messageIconUrl from './assets/message-icon.svg';
import meterIconUrl from './assets/meter-icon.svg';
import miniAscendingIconUrl from './assets/mini-ascending-icon.svg';
import miniChevronDownIconUrl from './assets/mini-chevron-down-icon.svg';
import miniChevronRightIconUrl from './assets/mini-chevron-right-icon.svg';
import miniCloseIconUrl from './assets/mini-close-icon.svg';
import miniDescendingIconUrl from './assets/mini-descending-icon.svg';
import miniUnsortedIconUrl from './assets/mini-unsorted-icon.svg';
import minusIconUrl from './assets/minus-icon.svg';
import moreIconUrl from './assets/more-icon.svg';
import orderIconUrl from './assets/order-icon.svg';
import petronasGreenIconUrl from './assets/petronas-green-icon.svg';
import petronasWhiteIconUrl from './assets/petronas-white-icon.svg';
import phone1IconUrl from './assets/phone1-icon.svg';
import phoneIconUrl from './assets/phone-icon.svg';
import plusIconUrl from './assets/plus-icon.svg';
import previewIconUrl from './assets/preview-icon.svg';
import printerIconUrl from './assets/printer-icon.svg';
import pumpIconUrl from './assets/pump-icon.svg';
import receiptIconUrl from './assets/receipt-icon.svg';
import reloadIconUrl from './assets/reload-icon.svg';
import replayIconUrl from './assets/replay-icon.svg';
import rewardsIconUrl from './assets/rewards-icon.svg';
import scanIconUrl from './assets/scan-icon.svg';
import searchIconUrl from './assets/search-icon.svg';
import setelDefaultIconUrl from './assets/setel-default-icon.svg';
import setelIconUrl from './assets/setel-icon.svg';
import setelLightIconUrl from './assets/setel-light-icon.svg';
import setelShareIconUrl from './assets/setel-share-icon.svg';
import setelWalletIconUrl from './assets/setel-wallet-icon.svg';
import settlementsIconUrl from './assets/settlements-icon.svg';
import shareIconUrl from './assets/share-icon.svg';
import shoppingBagIconUrl from './assets/shopping-bag-icon.svg';
import singaporeFlagIconUrl from './assets/singapore-flag-icon.svg';
import smartPayDarkIconUrl from './assets/smart-pay-dark-icon.svg';
import smartPayLightIconUrl from './assets/smart-pay-light-icon.svg';
import sparklesIconUrl from './assets/sparkles-icon.svg';
import spinIconUrl from './assets/spin-icon.svg';
import starIconUrl from './assets/star-icon.svg';
import syncIconUrl from './assets/sync-icon.svg';
import thaiFlagIconUrl from './assets/thai-flag-icon.svg';
import topupIconUrl from './assets/topup-icon.svg';
import transmissionIconUrl from './assets/transmission-icon.svg';
import trashIconUrl from './assets/trash-icon.svg';
import uploadIconUrl from './assets/upload-icon.svg';
import userCircleIconUrl from './assets/user-circle-icon.svg';
import userIconUrl from './assets/user-icon.svg';
import vehicleIconUrl from './assets/vehicle-icon.svg';
import verifiedIconUrl from './assets/verified-icon.svg';
import videoIconUrl from './assets/video-icon.svg';
import visaIconUrl from './assets/visa-icon.svg';
import voidSalesIconUrl from './assets/void-sales-icon.svg';
import voucherIconUrl from './assets/voucher-icon.svg';
import walletIconUrl from './assets/wallet-icon.svg';
import warningIconUrl from './assets/warning-icon.svg';
import zoomInIconUrl from './assets/zoom-in-icon.svg';
export { useId } from '@reach/auto-id';
import axios from 'axios';
import { createCDNUtils as createCDNUtils$1 } from '@setel/cdn-sdk';
import { createPortal } from 'react-dom';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param element
 */

function getOwnerDocument(element) {
  return canUseDOM() ? element ? element.ownerDocument : document : null;
}
/**
 * TODO: Remove in 1.0
 */

function getOwnerWindow(element) {
  var ownerDocument = getOwnerDocument(element);
  return ownerDocument ? ownerDocument.defaultView || window : null;
}

/**
 * Get computed style properties of a DOM element.
 *
 * @param element
 * @param styleProp
 */

function getComputedStyles(element) {
  var ownerWindow = getOwnerWindow(element);

  if (ownerWindow) {
    return ownerWindow.getComputedStyle(element, null);
  }

  return null;
}
/**
 * Get a computed style value by property.
 *
 * @param element
 * @param styleProp
 */

function getComputedStyle(element, styleProp) {
  var _getComputedStyles;

  return ((_getComputedStyles = getComputedStyles(element)) == null ? void 0 : _getComputedStyles.getPropertyValue(styleProp)) || null;
}

/**
 * Flatten an array recursively
 *
 * @see https://github.com/jonschlinkert/arr-flatten
 * @license MIT
 */
function flattenArray(nestedArray) {
    const result = [];
    flatten(nestedArray, result);
    return result;
}
function flatten(input, result) {
    let arrLen = input.length;
    let index = 0;
    while (arrLen--) {
        const current = input[index++];
        if (Array.isArray(current)) {
            flatten(current, result);
        }
        else {
            result.push(current);
        }
    }
}
/**
 * Create an array with particular length
 *
 * @param length the length of the array to be created
 * @param filler the value of all elements in the array
 */
const createArray = (length, filler = undefined) => {
    const result = [];
    for (let index = 0; index < length; index++) {
        result.push(filler);
    }
    return result;
};
/**
 * Returns the index of the last element in the array where predicate is true, and -1
 * otherwise.
 * @param array The source array to search in
 * @param predicate find calls predicate once for each element of the array, in descending
 * order, until it finds one where predicate returns true. If such an element is found,
 * findLastIndex immediately returns that element index. Otherwise, findLastIndex returns -1.
 */
function findLastIndex(array, predicate) {
    let l = array.length;
    while (l--) {
        if (predicate(array[l], l, array))
            return l;
    }
    return -1;
}
/**
 * Iterate array like list, e.g. NodeList
 */
function forEach(list, callback) {
    for (let index = 0; index < list.length; index++) {
        const element = list[index];
        callback(element, index);
    }
}
function toArray(list) {
    const result = [];
    forEach(list, (i) => result.push(i));
    return result;
}
function isSimilarArray(arrayOne, arrayTwo) {
    if (arrayOne === arrayTwo) {
        return true;
    }
    if (arrayOne.length !== arrayTwo.length) {
        return false;
    }
    return arrayOne.every((item, index) => item === arrayTwo[index]);
}
const arrayMoveMutate = (array, from, to) => {
    const startIndex = from < 0 ? array.length + from : from;
    if (startIndex >= 0 && startIndex < array.length) {
        const endIndex = to < 0 ? array.length + to : to;
        const [item] = array.splice(from, 1);
        array.splice(endIndex, 0, item);
    }
};
/**
 * Move an array item to a different position.
 *
 * Shamelessly copied from `array-move`
 */
const arrayMove = (array, from, to) => {
    const result = [...array];
    arrayMoveMutate(result, from, to);
    return result;
};
/**
 * Dedupe array item
 *
 * Based on implementation from https://github.com/jonschlinkert/array-unique.
 *
 * @param array array that you wish to dedupe.
 * @param uniqueKey properties to compare. If not provided, we will shallow compare the equality of the item.
 */
function dedupeArray(array, uniqueKey) {
    const arr = array.slice();
    const len = arr.length;
    let i = -1;
    while (i++ < len) {
        var j = i + 1;
        for (; j < arr.length; ++j) {
            if (uniqueKey ? arr[i][uniqueKey] === arr[j][uniqueKey] : arr[i] === arr[j]) {
                arr.splice(j--, 1);
            }
        }
    }
    return arr;
}

/**
 * A higher order component to default props for SVG component
 */
const withDefaultSvgProps = (Component) => {
    const Decorated = (props) => (React.createElement(Component, Object.assign({ "aria-hidden": true, focusable: false }, props)));
    Decorated.displayName = `withDefaultSvgProps(${Component.displayName || Component.name})`;
    return Decorated;
};
const useDefaultSvgProps = (props) => (Object.assign({ 'aria-hidden': true, focusable: false }, props));

const Dots = /*#__PURE__*/React.forwardRef(function Dots(_a, ref) {
    var { count, size = 4, spacing = 4 } = _a, providedProps = __rest(_a, ["count", "size", "spacing"]);
    const props = useDefaultSvgProps(providedProps);
    if (count < 1) {
        return null;
    }
    const width = count * size + (count - 1) * spacing;
    return (React.createElement("svg", Object.assign({ viewBox: `0 0 ${width} ${size}`, width: width, height: size }, props, { ref: ref }), createArray(count).map((_, index) => (React.createElement("circle", { cx: size / 2 + index * (spacing + size), cy: size / 2, r: size / 2, fill: "#2D333A", key: index })))));
});

const ToggleIcon = /*#__PURE__*/withDefaultSvgProps(function ToggleIcon(_a) {
    var { icon } = _a, props = __rest(_a, ["icon"]);
    return (React.createElement("svg", Object.assign({ fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, stroke: "currentColor" }, props),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M18 12H6" }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, style: {
                transitionProperty: 'transform',
                transitionDuration: '0.15s',
                transitionTimingFunction: 'cubic-bezier(.4,0,.2,1)',
                transformOrigin: 'bottom',
                transform: icon === 'plus' ? 'scaleY(1)' : 'scaleY(0)',
            }, d: "M12 6V18" })));
});

var svgId = {};

Object.defineProperty(svgId, "__esModule", { value: true });
svgId.SVG_ID = void 0;
svgId.SVG_ID = 'icon';

const { SVG_ID } = svgId;

var SVG_ID_1 = SVG_ID;

const includeFiles = new Map();
/**
 * Fetches an include file from a remote source.
 * Caching is enabled so the origin is only pinged once.
 */
function requestInclude(src, mode = 'cors') {
    if (includeFiles.has(src)) {
        return includeFiles.get(src);
    }
    const fileDataPromise = fetch(src, { mode: mode }).then((response) => __awaiter(this, void 0, void 0, function* () {
        return {
            ok: response.ok,
            status: response.status,
            text: yield response.text(),
        };
    }));
    includeFiles.set(src, fileDataPromise);
    return fileDataPromise;
}

var parser;
// The approach: fetch() external .svg file content & DOMParser.parse it to retrieve innerHTML
// (without <svg> outer tag).
function getExternalSvg(originalHref) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { ok, status, text: svgRaw } = yield requestInclude(originalHref);
            if (!ok) {
                throw new Error(`FetchError: ${status} status`);
            }
            // Create an instance of the DOM parser. We do it here instead of top-level to support SSR
            // while maintaining a single parser instance for optimal performance.
            if (!parser) {
                parser = new DOMParser();
            }
            const doc = parser.parseFromString(svgRaw, 'text/html');
            const svgEl = doc.body.querySelector('svg');
            if (svgEl) {
                return svgEl;
            }
        }
        catch (err) {
            if (err instanceof Error) {
                console.error(err);
            }
            else {
                console.error(new Error('Unexpected error'), err);
            }
        }
    });
}
// Another (slower) approach to consider is fetch() &
// href = URL.createObjectURL(new Blob(await response.blob(), { type: 'image/svg+xml' })).
// This way we can keep using `<use href={href}>` for both local & external .svg files.
// `URL.createObjectURL` is slow & blocking (1-2ms depends on svg size) we might need to
// off-load it (or this whole fn) into Web Worker .eg https://github.com/developit/greenlet.

function createIcon(...args) {
    const [href, ...rest] = args;
    return createIconImpl(
    // Transform passed href with predefined ID.
    //
    // WHY?? we had our own `svg-loader` to automatically adds id & append hash to imported svg
    // but outside of Webpack it'll only return a url to svg file without the hash.
    // Thus here we force any passed url (with or without hash) to include predefined hash
    // used in `svg-loader` (hence the `svg-id` import) so it's ensured to be in sync.
    //
    // This means all .svg files that participate with this func are expected to have both
    // [id] & [xmlns] attributes. This is automatically handled with our Rollup plugin.
    //
    // This also means we need to document this behavior if we were to exposes this function out,
    // for now it should be internal.
    forceEndingHash(getUrlFromSvgImport(href), SVG_ID_1), ...rest);
}
function forceEndingHash(href, id) {
    const [url] = href.split('#');
    return url + '#' + id;
}
function createIconImpl(url, name = 'SvgIcon', defaultSvgProps = {}) {
    const href = getUrlFromSvgImport(url);
    const SvgIcon = React.forwardRef((userProps, forwardedRef) => {
        const _a = useDefaultSvgProps(Object.assign(Object.assign({}, defaultSvgProps), userProps)), props = __rest(_a, ["children"]);
        const [{ viewBox, innerHTML }, setSvg] = React.useState(() => {
            var _a;
            return ({
                viewBox: (_a = props.viewBox) !== null && _a !== void 0 ? _a : '0 0 24 24',
                innerHTML: shouldFetchSvg(href)
                    ? // Putting different-domain url in <use href={...}> throws "Unsafe" DOM Error,
                        // hence we check it early & render empty innerHTML to avoid above DOM errors in console.
                        ''
                    : `<use href="${href}"></use>`,
            });
        });
        React.useEffect(() => {
            // Fetch & inject svg content for "external" svg files.
            // Normally we don't need this in a web app context: icons files should be uploaded & served
            // under same domain with running web app. However for rare cases where we need to import
            // icons from a different (remote) web app, we'll need to fetch if the remote app is served
            // on a different domain.
            if (shouldFetchSvg(href)) {
                getExternalSvg(href).then((el) => {
                    if (el) {
                        const fetchedViewBox = el.getAttribute('viewBox');
                        setSvg((prev) => ({
                            innerHTML: el.innerHTML,
                            // Also update `viewBox` taken from external svg.
                            // When using <use> tag we don't have to worry about setting correct viewBox
                            // because the external .svg file should've had it defined.
                            // However, in `fetch` mode the external svg's content will be injected
                            // to our "svg shell" here and our `viewBox` might not match with the external svg,
                            // causing possibly broken icons.
                            viewBox: fetchedViewBox || prev.viewBox,
                        }));
                    }
                });
            }
        }, []);
        return (React.createElement("svg", Object.assign({ viewBox: viewBox, width: 24, height: 24 }, props, { ref: forwardedRef, dangerouslySetInnerHTML: { __html: innerHTML } })));
    });
    SvgIcon.displayName = name;
    return Object.assign(SvgIcon, { href: href, id: SVG_ID_1 });
}
function getUrlFromSvgImport(svgImport) {
    return typeof svgImport === 'string' ? svgImport : svgImport.src;
}
function shouldFetchSvg(href) {
    if (typeof document !== 'undefined') {
        const iconUrl = new URL(href, window.location.origin // default to current origin if href is not a full url
        );
        if (
        // Putting different-domain url in <use href={...}> throws "Unsafe" DOM Error,
        // so we manually fetch it & parse svg from response.
        // This ensures icons from remotes work eventhough they're hosted in different domains.
        window.location.origin !== iconUrl.origin ||
            // <use href={...}> only works if `href` contains a `hash` that points to svg's id value,
            // thus if provided same-host href doesn't contain a hash we also need to fetch & parse.
            !iconUrl.hash) {
            return true;
        }
    }
}

const AddImageIcon = /*#__PURE__*/createIcon(addImageIconUrl, 'AddImageIcon');
const AmexIcon = /*#__PURE__*/createIcon(amexIconUrl, 'AmexIcon');
const ArrowLeftIcon = /*#__PURE__*/createIcon(arrowLeftIconUrl, 'ArrowLeftIcon');
const ArrowRightInCircleIcon = /*#__PURE__*/createIcon(arrowRightInCircleIconUrl, 'ArrowRightInCircleIcon');
const BadgeIcon = /*#__PURE__*/createIcon(badgeIconUrl, 'BadgeIcon');
const BankIcon = /*#__PURE__*/createIcon(bankIconUrl, 'BankIcon');
const BellIcon = /*#__PURE__*/createIcon(bellIconUrl, 'BellIcon');
const BigCheckIcon = /*#__PURE__*/createIcon(bigCheckIconUrl, 'BigCheckIcon');
const BookIcon = /*#__PURE__*/createIcon(bookIconUrl, 'BookIcon');
const BoxIcon = /*#__PURE__*/createIcon(boxIconUrl, 'BoxIcon');
const BrokenLinkIcon = /*#__PURE__*/createIcon(brokenLinkIconUrl, 'BrokenLinkIcon');
const BusinessIcon = /*#__PURE__*/createIcon(businessIconUrl, 'BusinessIcon');
const CalendarIcon = /*#__PURE__*/createIcon(calendarIconUrl, 'CalendarIcon');
const CameraIcon = /*#__PURE__*/createIcon(cameraIconUrl, 'CameraIcon');
const CardIcon = /*#__PURE__*/createIcon(cardIconUrl, 'CardIcon');
const CardsIcon = /*#__PURE__*/createIcon(cardsIconUrl, 'CardsIcon');
const CartIcon = /*#__PURE__*/createIcon(cartIconUrl, 'CartIcon');
const CheckIcon = /*#__PURE__*/createIcon(checkIconUrl, 'CheckIcon');
const CheckInCircleIcon = /*#__PURE__*/createIcon(checkInCircleIconUrl, 'CheckInCircleIcon');
const CheckInCircleOutlineIcon = /*#__PURE__*/createIcon(checkInCircleOutlineIconUrl, 'CheckInCircleOutlineIcon');
const CheckedIcon = /*#__PURE__*/createIcon(checkedIconUrl, 'CheckedIcon');
const ChevronDoubleRightIcon = /*#__PURE__*/createIcon(chevronDoubleRightIconUrl, 'ChevronDoubleRightIcon');
const ChevronDownIcon = /*#__PURE__*/createIcon(chevronDownIconUrl, 'ChevronDownIcon');
const ChevronLeftIcon = /*#__PURE__*/createIcon(chevronLeftIconUrl, 'ChevronLeftIcon');
const ChevronRightIcon = /*#__PURE__*/createIcon(chevronRightIconUrl, 'ChevronRightIcon');
const ChevronUpIcon = /*#__PURE__*/createIcon(chevronUpIconUrl, 'ChevronUpIcon');
const CircleIcon = /*#__PURE__*/createIcon(circleIconUrl, 'CircleIcon');
const CircleMinusIcon = /*#__PURE__*/createIcon(circleMinusIconUrl, 'CircleMinusIcon');
const ClipboardIcon = /*#__PURE__*/createIcon(clipboardIconUrl, 'ClipboardIcon');
const ClockIcon = /*#__PURE__*/createIcon(clockIconUrl, 'ClockIcon');
const CogIcon = /*#__PURE__*/createIcon(cogIconUrl, 'CogIcon');
const CompassIcon = /*#__PURE__*/createIcon(compassIconUrl, 'CompassIcon');
const ContactBookIcon = /*#__PURE__*/createIcon(contactBookIconUrl, 'ContactBookIcon');
const CookiesIcon = /*#__PURE__*/createIcon(cookiesIconUrl, 'CookiesIcon');
const CopyIcon = /*#__PURE__*/createIcon(copyIconUrl, 'CopyIcon');
const CreditCardIcon = /*#__PURE__*/createIcon(creditCardIconUrl, 'CreditCardIcon');
const CrossIcon = /*#__PURE__*/createIcon(crossIconUrl, 'CrossIcon');
const CrossInCircleIcon = /*#__PURE__*/createIcon(crossInCircleIconUrl, 'CrossInCircleIcon');
const DesktopIcon = /*#__PURE__*/createIcon(desktopIconUrl, 'DesktopIcon');
const DiamondIcon = /*#__PURE__*/createIcon(diamondIconUrl, 'DiamondIcon');
const DocIcon = /*#__PURE__*/createIcon(docIconUrl, 'DocIcon');
const DocumentIcon = /*#__PURE__*/createIcon(documentIconUrl, 'DocumentIcon');
const DotHorizontalIcon = /*#__PURE__*/createIcon(dotHorizontalIconUrl, 'DotHorizontalIcon');
const DotVerticalIcon = /*#__PURE__*/createIcon(dotVerticalIconUrl, 'DotVerticalIcon');
const DownloadIcon = /*#__PURE__*/createIcon(downloadIconUrl, 'DownloadIcon');
const EVChargingIcon = /*#__PURE__*/createIcon(evChargingIconUrl, 'EVChargingIcon');
const EditIcon = /*#__PURE__*/createIcon(editIconUrl, 'EditIcon');
const EngineIcon = /*#__PURE__*/createIcon(engineIconUrl, 'EngineIcon');
const ErrorIcon = /*#__PURE__*/createIcon(errorIconUrl, 'ErrorIcon');
const ExclamationIcon = /*#__PURE__*/createIcon(exclamationIconUrl, 'ExclamationIcon');
const ExpandLessIcon = /*#__PURE__*/createIcon(expandLessIconUrl, 'ExpandLessIcon');
const ExpandMoreIcon = /*#__PURE__*/createIcon(expandMoreIconUrl, 'ExpandMoreIcon');
const ExternalIcon = /*#__PURE__*/createIcon(externalIconUrl, 'ExternalIcon');
const EyeHideIcon = /*#__PURE__*/createIcon(eyeHideIconUrl, 'EyeHideIcon');
const EyeShowIcon = /*#__PURE__*/createIcon(eyeShowIconUrl, 'EyeShowIcon');
const FamilyIcon = /*#__PURE__*/createIcon(familyIconUrl, 'FamilyIcon');
const FilledStarIcon = /*#__PURE__*/createIcon(filledStarIconUrl, 'FilledStarIcon');
const FilterIcon = /*#__PURE__*/createIcon(filterIconUrl, 'FilterIcon');
const FuelTankIcon = /*#__PURE__*/createIcon(fuelTankIconUrl, 'FuelTankIcon');
const GasTankIcon = /*#__PURE__*/createIcon(gasTankIconUrl, 'GasTankIcon');
const HeartIcon = /*#__PURE__*/createIcon(heartIconUrl, 'HeartIcon');
const HelpIcon = /*#__PURE__*/createIcon(helpIconUrl, 'HelpIcon');
const HistoryIcon = /*#__PURE__*/createIcon(historyIconUrl, 'HistoryIcon');
const ImageIcon = /*#__PURE__*/createIcon(imageIconUrl, 'ImageIcon');
const InboxIcon = /*#__PURE__*/createIcon(inboxIconUrl, 'InboxIcon');
const InfoIcon = /*#__PURE__*/createIcon(infoIconUrl, 'InfoIcon');
const InfoOutlineIcon = /*#__PURE__*/createIcon(infoOutlineIconUrl, 'InfoOutlineIcon');
const InviteIcon = /*#__PURE__*/createIcon(inviteIconUrl, 'InviteIcon');
const LanguageIcon = /*#__PURE__*/createIcon(languageIconUrl, 'LanguageIcon');
const LifebuoyIcon = /*#__PURE__*/createIcon(lifebuoyIconUrl, 'LifebuoyIcon');
const LinkIcon = /*#__PURE__*/createIcon(linkIconUrl, 'LinkIcon');
const ListIcon = /*#__PURE__*/createIcon(listIconUrl, 'ListIcon');
const LocationIcon = /*#__PURE__*/createIcon(locationIconUrl, 'LocationIcon');
const LockIcon = /*#__PURE__*/createIcon(lockIconUrl, 'LockIcon');
const LogoutIcon = /*#__PURE__*/createIcon(logoutIconUrl, 'LogoutIcon');
const LorryIcon = /*#__PURE__*/createIcon(lorryIconUrl, 'LorryIcon');
const LoudspeakerIcon = /*#__PURE__*/createIcon(loudspeakerIconUrl, 'LoudspeakerIcon');
const MailIcon = /*#__PURE__*/createIcon(mailIconUrl, 'MailIcon');
const MalaysiaFlagIcon = /*#__PURE__*/createIcon(
  malaysiaFlagIconUrl,
  'MalaysiaFlagIcon',
  { viewBox: '0 0 30 22', width: 30, height: 22 }
);
const MapIcon = /*#__PURE__*/createIcon(mapIconUrl, 'MapIcon');
const MastercardIcon = /*#__PURE__*/createIcon(mastercardIconUrl, 'MastercardIcon');
const MembershipIcon = /*#__PURE__*/createIcon(membershipIconUrl, 'MembershipIcon');
const MenuIcon = /*#__PURE__*/createIcon(menuIconUrl, 'MenuIcon');
const MerchantIcon = /*#__PURE__*/createIcon(merchantIconUrl, 'MerchantIcon');
const MesraCardIcon = /*#__PURE__*/createIcon(mesraCardIconUrl, 'MesraCardIcon');
const MessageIcon = /*#__PURE__*/createIcon(messageIconUrl, 'MessageIcon');
const MeterIcon = /*#__PURE__*/createIcon(meterIconUrl, 'MeterIcon');
const MiniAscendingIcon = /*#__PURE__*/createIcon(miniAscendingIconUrl, 'MiniAscendingIcon');
const MiniChevronDownIcon = /*#__PURE__*/createIcon(miniChevronDownIconUrl, 'MiniChevronDownIcon');
const MiniChevronRightIcon = /*#__PURE__*/createIcon(miniChevronRightIconUrl, 'MiniChevronRightIcon');
const MiniCloseIcon = /*#__PURE__*/createIcon(miniCloseIconUrl, 'MiniCloseIcon');
const MiniDescendingIcon = /*#__PURE__*/createIcon(miniDescendingIconUrl, 'MiniDescendingIcon');
const MiniUnsortedIcon = /*#__PURE__*/createIcon(miniUnsortedIconUrl, 'MiniUnsortedIcon');
const MinusIcon = /*#__PURE__*/createIcon(minusIconUrl, 'MinusIcon');
const MoreIcon = /*#__PURE__*/createIcon(moreIconUrl, 'MoreIcon');
const OrderIcon = /*#__PURE__*/createIcon(orderIconUrl, 'OrderIcon');
const PetronasGreenIcon = /*#__PURE__*/createIcon(petronasGreenIconUrl, 'PetronasGreenIcon');
const PetronasWhiteIcon = /*#__PURE__*/createIcon(petronasWhiteIconUrl, 'PetronasWhiteIcon');
const Phone1Icon = /*#__PURE__*/createIcon(phone1IconUrl, 'Phone1Icon');
const PhoneIcon = /*#__PURE__*/createIcon(phoneIconUrl, 'PhoneIcon');
const PlusIcon = /*#__PURE__*/createIcon(plusIconUrl, 'PlusIcon');
const PreviewIcon = /*#__PURE__*/createIcon(previewIconUrl, 'PreviewIcon');
const PrinterIcon = /*#__PURE__*/createIcon(printerIconUrl, 'PrinterIcon');
const PumpIcon = /*#__PURE__*/createIcon(pumpIconUrl, 'PumpIcon');
const ReceiptIcon = /*#__PURE__*/createIcon(receiptIconUrl, 'ReceiptIcon');
const ReloadIcon = /*#__PURE__*/createIcon(reloadIconUrl, 'ReloadIcon');
const ReplayIcon = /*#__PURE__*/createIcon(replayIconUrl, 'ReplayIcon');
const RewardsIcon = /*#__PURE__*/createIcon(rewardsIconUrl, 'RewardsIcon');
const ScanIcon = /*#__PURE__*/createIcon(scanIconUrl, 'ScanIcon');
const SearchIcon = /*#__PURE__*/createIcon(searchIconUrl, 'SearchIcon');
const SetelDefaultIcon = /*#__PURE__*/createIcon(setelDefaultIconUrl, 'SetelDefaultIcon');
const SetelIcon = /*#__PURE__*/createIcon(setelIconUrl, 'SetelIcon');
const SetelLightIcon = /*#__PURE__*/createIcon(setelLightIconUrl, 'SetelLightIcon');
const SetelShareIcon = /*#__PURE__*/createIcon(setelShareIconUrl, 'SetelShareIcon');
const SetelWalletIcon = /*#__PURE__*/createIcon(setelWalletIconUrl, 'SetelWalletIcon');
const SettlementsIcon = /*#__PURE__*/createIcon(settlementsIconUrl, 'SettlementsIcon');
const ShareIcon = /*#__PURE__*/createIcon(shareIconUrl, 'ShareIcon');
const ShoppingBagIcon = /*#__PURE__*/createIcon(shoppingBagIconUrl, 'ShoppingBagIcon');
const SingaporeFlagIcon = /*#__PURE__*/createIcon(singaporeFlagIconUrl, 'SingaporeFlagIcon');
const SmartPayDarkIcon = /*#__PURE__*/createIcon(smartPayDarkIconUrl, 'SmartPayDarkIcon');
const SmartPayLightIcon = /*#__PURE__*/createIcon(smartPayLightIconUrl, 'SmartPayLightIcon');
const SparklesIcon = /*#__PURE__*/createIcon(sparklesIconUrl, 'SparklesIcon');
const SpinIcon = /*#__PURE__*/createIcon(spinIconUrl, 'SpinIcon');
const StarIcon = /*#__PURE__*/createIcon(starIconUrl, 'StarIcon');
const SyncIcon = /*#__PURE__*/createIcon(syncIconUrl, 'SyncIcon');
const ThaiFlagIcon = /*#__PURE__*/createIcon(thaiFlagIconUrl, 'ThaiFlagIcon');
const TopupIcon = /*#__PURE__*/createIcon(topupIconUrl, 'TopupIcon');
const TransmissionIcon = /*#__PURE__*/createIcon(transmissionIconUrl, 'TransmissionIcon');
const TrashIcon = /*#__PURE__*/createIcon(trashIconUrl, 'TrashIcon');
const UploadIcon = /*#__PURE__*/createIcon(uploadIconUrl, 'UploadIcon');
const UserCircleIcon = /*#__PURE__*/createIcon(userCircleIconUrl, 'UserCircleIcon');
const UserIcon = /*#__PURE__*/createIcon(userIconUrl, 'UserIcon');
const VehicleIcon = /*#__PURE__*/createIcon(vehicleIconUrl, 'VehicleIcon');
const VerifiedIcon = /*#__PURE__*/createIcon(verifiedIconUrl, 'VerifiedIcon');
const VideoIcon = /*#__PURE__*/createIcon(videoIconUrl, 'VideoIcon');
const VisaIcon = /*#__PURE__*/createIcon(visaIconUrl, 'VisaIcon');
const VoidSalesIcon = /*#__PURE__*/createIcon(voidSalesIconUrl, 'VoidSalesIcon');
const VoucherIcon = /*#__PURE__*/createIcon(voucherIconUrl, 'VoucherIcon');
const WalletIcon = /*#__PURE__*/createIcon(walletIconUrl, 'WalletIcon');
const WarningIcon = /*#__PURE__*/createIcon(warningIconUrl, 'WarningIcon');
const ZoomInIcon = /*#__PURE__*/createIcon(zoomInIconUrl, 'ZoomInIcon');

let tempId = -Date.now();
function getId(number = false) {
    return number ? tempId++ : `setel-${tempId++}`;
}

// @overview: Type guards allows you to check the type of variable while allowing TypeScript to infer the type correctly
const isDefined = (value) => typeof value !== 'undefined';
const isNil = (value) => typeof value === 'undefined' || value === null;
const isPrimitive = (value) => /^(b|st|n)/.test(typeof value);
const isEmptyObject = (value) => !!value && Object.keys(value).length === 0 && value.constructor === Object;
function isEmptyValue(value) {
    return (isNil(value) ||
        ((isString(value) || Array.isArray(value)) && value.length === 0) ||
        isEmptyObject(value));
}

const useAjaxOperations = ({ operation: uploadOperation, onChange: providedOnChange, autoRemoveDelayWhenSuccess, }) => {
    const onChange = useStableCallback(providedOnChange);
    const cancelMap = useConstant(() => new Map());
    const runUploadMap = useConstant(() => new Map());
    const autoRemoveMap = useConstant(() => new Map());
    const [state, dispatch] = React.useReducer(ajaxOperationReducer, {
        items: [],
    });
    const stateValue = state;
    const cleanup = useStableCallback(function cleanup() {
        cancelMap.forEach((cancel) => cancel());
        cancelMap.clear();
        autoRemoveMap.forEach((timerId) => window.clearTimeout(timerId));
        autoRemoveMap.clear();
        runUploadMap.clear();
    });
    React.useEffect(() => cleanup, [cleanup]);
    const removeItem = ({ key, }) => {
        const cancel = cancelMap.get(key);
        if (cancel) {
            cancel();
            cancelMap.delete(key);
        }
        const autoRemoveTimer = autoRemoveMap.get(key);
        if (isDefined(autoRemoveTimer)) {
            window.clearTimeout(autoRemoveTimer);
            autoRemoveMap.delete(key);
        }
        runUploadMap.delete(key);
        dispatch({
            type: 'remove',
            key,
        });
    };
    const add = useStableCallback((input, addOptions = {}) => {
        const key = getId();
        function runUpload() {
            const cancelFns = [];
            const onError = (errorMsg) => dispatch({
                type: 'error',
                errorMessage: errorMsg || undefined,
                key,
            });
            const inputs = Array.isArray(input)
                ? input
                : [{ input }];
            function executeUpload(executionData, retryCount = 0, prevData) {
                const [{ input: currentInput, shouldRetry, shouldError, onComplete, retryDelay, }, ...rest] = executionData;
                return uploadOperation(currentInput, {
                    prevData,
                    onError,
                    numOfTotalRequests: inputs.length,
                    numOfCompletedRequests: inputs.length - executionData.length,
                    onProgress: (progress) => dispatch({
                        type: 'progress',
                        progress,
                        key,
                    }),
                    onComplete: (result) => {
                        if (isFunction(onComplete)) {
                            onComplete(result);
                        }
                        if (isFunction(shouldRetry) &&
                            shouldRetry(result, { retryCount })) {
                            const delay = getRetryDelay(retryCount, retryDelay);
                            const timerId = setTimeout(() => {
                                const { cancel } = executeUpload(executionData, retryCount + 1, prevData);
                                cancelFns.push(cancel);
                            }, delay);
                            cancelFns.push(function cancelTimer() {
                                clearTimeout(timerId);
                            });
                            return;
                        }
                        if (isFunction(shouldError)) {
                            const error = shouldError(result);
                            if (isString(error)) {
                                onError(error);
                                return;
                            }
                        }
                        if (rest.length === 0) {
                            dispatch({
                                type: 'complete',
                                key,
                                result,
                            });
                            cancelMap.delete(key);
                            runUploadMap.delete(key);
                            if (isDefined(addOptions.autoRemoveDelayWhenSuccess)) {
                                const providedDelay = addOptions.autoRemoveDelayWhenSuccess;
                                if (providedDelay !== false) {
                                    const autoRemoveTimerId = window.setTimeout(() => {
                                        dispatch({
                                            type: 'remove',
                                            key,
                                        });
                                        autoRemoveMap.delete(key);
                                    }, providedDelay);
                                    autoRemoveMap.set(key, autoRemoveTimerId);
                                }
                            }
                            else if (isDefined(autoRemoveDelayWhenSuccess)) {
                                const autoRemoveTimerId = window.setTimeout(() => {
                                    dispatch({
                                        type: 'remove',
                                        key,
                                    });
                                    autoRemoveMap.delete(key);
                                }, autoRemoveDelayWhenSuccess);
                                autoRemoveMap.set(key, autoRemoveTimerId);
                            }
                            if (isFunction(addOptions.onComplete)) {
                                addOptions.onComplete(result);
                            }
                        }
                        else {
                            const { cancel } = executeUpload(rest, 0, result);
                            cancelFns.push(cancel);
                        }
                    },
                });
            }
            const { cancel } = executeUpload(inputs);
            cancelFns.push(cancel);
            return {
                cancel: () => cancelFns.forEach((fn) => fn()),
            };
        }
        const { cancel } = runUpload();
        cancelMap.set(key, cancel);
        runUploadMap.set(key, runUpload);
        dispatch({
            type: 'add',
            inputs: Array.isArray(input)
                ? input.map((data) => data.input)
                : [input],
            key,
        });
    });
    const records = [];
    const items = [];
    stateValue.items.forEach((item) => {
        switch (item.status) {
            case 'success':
                {
                    records.push(item);
                    items.push(Object.assign(Object.assign({}, item), { onRemove: () => removeItem(item), onRetry: undefined }));
                }
                break;
            case 'error':
                {
                    items.push(Object.assign(Object.assign({}, item), { onRemove: () => removeItem(item), onRetry: () => {
                            const key = item.key;
                            dispatch({
                                type: 'retry',
                                key,
                            });
                            const runUpload = runUploadMap.get(key);
                            if (runUpload) {
                                const { cancel } = runUpload();
                                cancelMap.set(key, cancel);
                            }
                        } }));
                }
                break;
            case 'pending':
                {
                    items.push(Object.assign(Object.assign({}, item), { onRemove: () => removeItem(item), onRetry: undefined }));
                }
                break;
        }
    });
    const previousResults = usePrevious(records);
    React.useEffect(() => {
        if (previousResults &&
            !isSimilarArray(previousResults, records)) {
            onChange(records.map((r) => r.result), {
                records: records.map((r) => ({
                    input: r.input,
                    result: r.result,
                    allInputs: r.allInputs,
                })),
            });
        }
    });
    return {
        add,
        results: records.map((r) => r.result),
        items,
        hasPendingRequest: stateValue.items.some((item) => item.status === 'pending'),
    };
};
const DEFAULT_RETRY_DELAY = [1000, 3000, 5000];
const getRetryDelay = (retryCount, retryDelay = DEFAULT_RETRY_DELAY) => isNumber(retryDelay)
    ? retryDelay
    : retryDelay[Math.min(retryCount, retryDelay.length - 1)];
const ajaxOperationReducer = (state, action) => {
    switch (action.type) {
        case 'add':
            return Object.assign(Object.assign({}, state), { items: state.items.concat({
                    input: action.inputs[0],
                    allInputs: action.inputs,
                    key: action.key,
                    status: 'pending',
                    progress: 0,
                }) });
        case 'progress':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.key === action.key && item.status === 'pending'
                    ? Object.assign(Object.assign({}, item), { progress: action.progress }) : item) });
        case 'complete':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.key === action.key && item.status === 'pending'
                    ? Object.assign(Object.assign({}, item), { progress: 100, status: 'success', result: action.result }) : item) });
        case 'error':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.key === action.key && item.status === 'pending'
                    ? Object.assign(Object.assign({}, item), { status: 'error', errorMessage: action.errorMessage }) : item) });
        case 'remove':
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.key !== action.key) });
        case 'retry':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.key === action.key && item.status === 'error'
                    ? Object.assign(Object.assign({}, item), { status: 'pending', progress: 0, errorMessage: undefined }) : item) });
        default:
            throw new Error(`Unsupported action: ${JSON.stringify(action)}`);
    }
};

/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */
function useCallbackRef(callback) {
    const callbackRef = React.useRef(callback);
    React.useEffect(() => {
        callbackRef.current = callback;
    });
    // https://github.com/facebook/react/issues/19240
    return React.useMemo(() => ((...args) => { var _a; return (_a = callbackRef.current) === null || _a === void 0 ? void 0 : _a.call(callbackRef, ...args); }), []);
}

function useControllableState({ prop, defaultProp, onChange = () => { }, }) {
    const [uncontrolledProp, setUncontrolledProp] = useUncontrolledState({
        defaultProp,
        onChange,
    });
    const isControlled = prop !== undefined;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = useCallbackRef(onChange);
    const setValue = React.useCallback((nextValue) => {
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === 'function' ? setter(prop) : nextValue;
            if (value !== prop)
                handleChange(value);
        }
        else {
            setUncontrolledProp(nextValue);
        }
    }, [isControlled, prop, setUncontrolledProp, handleChange]);
    return [value, setValue];
}
function useUncontrolledState({ defaultProp, onChange, }) {
    const uncontrolledState = React.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = React.useRef(value);
    const handleChange = useCallbackRef(onChange);
    React.useEffect(() => {
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [value, prevValueRef, handleChange]);
    return uncontrolledState;
}

/**
 * `useDebounce` allows you to debounce the update of a variable/state value.
 *
 * @param value value that you wish to debounce, e.g. the input value of a search field
 * @param wait wait time before the debounced value is updated
 */
const useDebounce = (value, wait = 500) => {
    const [dValue, setDValue] = React.useState(value);
    React.useEffect(() => {
        const timerId = window.setTimeout(() => setDValue(value), wait);
        return () => window.clearTimeout(timerId);
    }, [value, wait]);
    return dValue;
};

const useDelayedCallback = (cb, delay = 3000) => {
    const latestCallback = useCallbackRef(cb);
    const latestTimerId = React.useRef();
    React.useEffect(() => {
        return function cleanup() {
            if (latestTimerId.current) {
                clearTimeout(latestTimerId.current);
            }
        };
    }, []);
    return React.useCallback(function cb(...args) {
        latestTimerId.current = setTimeout(() => {
            latestCallback(...args);
        }, delay);
    }, []);
};

const useDescendantState = (initialState) => {
    const stateRef = React.useRef(initialState);
    const hasChangeRef = React.useRef(false);
    const forceUpdate = useForceUpdate();
    React.useEffect(() => {
        if (hasChangeRef.current) {
            forceUpdate();
            hasChangeRef.current = false;
        }
    });
    const setState = React.useCallback((value) => {
        if (isFunction(value)) {
            const nextValue = value(stateRef.current);
            if (nextValue !== stateRef.current) {
                stateRef.current = nextValue;
                hasChangeRef.current = true;
            }
        }
        else {
            if (value !== stateRef.current) {
                stateRef.current = value;
                hasChangeRef.current = true;
            }
        }
    }, []);
    return [stateRef.current, setState];
};
const createDescendantContext = (name, defaultValue) => {
    const Context = createNamedContext(name, [defaultValue, noop$1]);
    const useDescendantValue = (value) => {
        const [val, setValue] = React.useContext(Context);
        setValue(value);
        return val;
    };
    return {
        Provider: Context.Provider,
        useDescendantValue,
    };
};

function pick(oriObject, keysToPick) {
    const result = {};
    keysToPick.forEach((key) => {
        const value = oriObject[key];
        if (isDefined(value)) {
            result[key] = value;
        }
    });
    return result;
}
function omit(oriObject, keysToOmit) {
    const result = Object.assign({}, oriObject);
    keysToOmit.forEach((key) => delete result[key]);
    return result;
}
/**
 * Combination of `pick` and `omit` operation.
 * @param oriObject
 * @param keys keys to included in the `picked` property and excluded from the `omitted` property in the result.
 */
function pickAndOmit(oriObject, keys) {
    const pick = {};
    const omit = Object.assign({}, oriObject);
    keys.forEach((key) => {
        const value = oriObject[key];
        if (isDefined(value)) {
            pick[key] = value;
        }
        delete omit[key];
    });
    return {
        picked: pick,
        omitted: omit,
    };
}

const useFileUploads = ({ uploadOperation, validateBeforeUpload, onChange, maxCount, removeWhenComplete, }) => {
    const cancelMap = useConstant(() => new WeakMap());
    const runUploadMap = useConstant(() => new WeakMap());
    const [state, dispatch] = React.useReducer(fileUploadReducer, {
        items: [],
    });
    const stateValue = state;
    const cancelInflightRequests = useStableCallback(() => {
        state.items.forEach((item) => {
            const cancel = cancelMap.get(item.file);
            if (cancel) {
                cancel();
            }
        });
    });
    React.useEffect(() => cancelInflightRequests, [cancelInflightRequests]);
    const removeItemByFile = (file) => {
        const cancel = cancelMap.get(file);
        if (cancel) {
            cancel();
        }
        cancelMap.delete(file);
        runUploadMap.delete(file);
        dispatch({
            type: 'remove',
            file,
        });
    };
    const removeItem = (item) => {
        removeItemByFile(item.file);
    };
    const addFile = useStableCallback((file) => {
        if (maxCount &&
            maxCount === stateValue.items.length &&
            stateValue.items.length > 0) {
            removeItem(stateValue.items[0]);
        }
        const validationResult = validateBeforeUpload && validateBeforeUpload(file);
        if (validationResult) {
            dispatch({
                type: 'addFile',
                file,
                key: getId(),
                errorMessage: validationResult,
            });
            return;
        }
        if (uploadOperation === 'local') {
            dispatch({
                type: 'addLocalFile',
                file,
                key: getId(),
            });
            return;
        }
        const runUpload = () => uploadOperation(file, {
            onProgress: (uploadProgress) => dispatch({
                type: 'fileUploadProgress',
                uploadProgress,
                file,
            }),
            onComplete: (result) => {
                if (removeWhenComplete) {
                    removeItemByFile(file);
                    if (onChange) {
                        onChange([]);
                    }
                }
                else {
                    dispatch({
                        type: 'completeUpload',
                        file,
                        result,
                    });
                    cancelMap.delete(file);
                }
            },
            onError: (errorMsg) => dispatch({
                type: 'error',
                errorMessage: errorMsg || undefined,
                file,
            }),
            numOfTotalRequests: 1,
            numOfCompletedRequests: 0,
        });
        const { cancel } = runUpload();
        cancelMap.set(file, cancel);
        runUploadMap.set(file, runUpload);
        dispatch({
            type: 'addFile',
            file,
            key: getId(),
        });
    });
    const uploadResults = [];
    const items = [];
    stateValue.items.forEach((item) => {
        switch (item.uploadStatus) {
            case 'completed':
                {
                    const { picked: { result }, omitted: itemResult, } = pickAndOmit(item, ['result']);
                    if (result) {
                        uploadResults.push(result);
                    }
                    items.push(Object.assign(Object.assign({}, itemResult), { onRemove: () => removeItem(item), onRetry: undefined }));
                }
                break;
            case 'error':
                {
                    const { picked: { noRetry }, omitted: itemResult, } = pickAndOmit(item, ['noRetry']);
                    items.push(Object.assign(Object.assign({}, itemResult), { onRemove: () => removeItem(item), onRetry: noRetry
                            ? undefined
                            : () => {
                                const file = item.file;
                                dispatch({
                                    type: 'retry',
                                    file,
                                });
                                const runUpload = runUploadMap.get(file);
                                if (runUpload) {
                                    const { cancel } = runUpload();
                                    cancelMap.set(file, cancel);
                                }
                            } }));
                }
                break;
            case 'uploading':
                {
                    items.push(Object.assign(Object.assign({}, item), { onRemove: () => removeItem(item), onRetry: undefined }));
                }
                break;
        }
    });
    const results = uploadOperation === 'local'
        ? items
            .filter((item) => item.uploadStatus === 'completed')
            .map((item) => item.file)
        : uploadResults;
    const previousResults = usePrevious(results);
    React.useEffect(() => {
        if (onChange &&
            previousResults &&
            !isSimilarArray(previousResults, results)) {
            onChange(results);
        }
    });
    return {
        addFile,
        results: uploadOperation === 'local'
            ? items
                .filter((item) => !isDefined(item.uploadStatus))
                .map((item) => item.file)
            : uploadResults,
        items,
        hasPendingRequest: uploadOperation === 'local'
            ? false
            : stateValue.items.some((item) => item.uploadStatus === 'uploading'),
    };
};
const fileUploadReducer = (state, action) => {
    switch (action.type) {
        case 'addFile':
            return Object.assign(Object.assign({}, state), { items: state.items.concat(Object.assign({ file: action.file, uploadStatus: action.errorMessage ? 'error' : 'uploading', errorMessage: action.errorMessage, uploadProgress: 0, key: action.key }, (action.errorMessage ? { noRetry: true } : {}))) });
        case 'addLocalFile':
            return Object.assign(Object.assign({}, state), { items: state.items.concat({
                    file: action.file,
                    uploadStatus: 'completed',
                    key: action.key,
                }) });
        case 'fileUploadProgress':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.file === action.file && item.uploadStatus === 'uploading'
                    ? Object.assign(Object.assign({}, item), { uploadProgress: action.uploadProgress }) : item) });
        case 'completeUpload':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.file === action.file && item.uploadStatus === 'uploading'
                    ? Object.assign(Object.assign({}, item), { uploadProgress: 100, uploadStatus: 'completed', result: action.result }) : item) });
        case 'error':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.file === action.file && item.uploadStatus === 'uploading'
                    ? Object.assign(Object.assign({}, item), { uploadStatus: 'error', errorMessage: action.errorMessage }) : item) });
        case 'remove':
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.file !== action.file) });
        case 'retry':
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.file === action.file && item.uploadStatus === 'error'
                    ? Object.assign(Object.assign({}, item), { uploadStatus: 'uploading', uploadProgress: 0, errorMessage: undefined }) : item) });
        default:
            throw new Error(`Unsupported action: ${JSON.stringify(action)}`);
    }
};

/**
 * `useImageDimensions` allows you to get the actual dimensions
 * of the image loaded in `img` element.
 */
const useImageDimensions = (imageRef, options) => {
    const [dimensions, setDimensions] = React.useState();
    const deps = options && options.dependencies;
    React.useEffect(() => {
        const img = imageRef.current;
        if (img) {
            const getImageDimensions = () => setDimensions({
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
            if (img.complete) {
                getImageDimensions();
            }
            else {
                img.addEventListener('load', getImageDimensions);
                return () => img.removeEventListener('load', getImageDimensions);
            }
        }
    }, [deps]);
    return dimensions;
};
const useImageFileDimensions = (file, { enabled = true, } = {}) => {
    const [dimensions, setDimensions] = React.useState();
    React.useEffect(() => {
        if (enabled && file) {
            const url = URL.createObjectURL(file);
            const img = new Image();
            img.onload = function () {
                setDimensions({
                    width: img.width,
                    height: img.height,
                });
            };
            img.src = url;
            return () => {
                URL.revokeObjectURL(url);
            };
        }
    }, [enabled, file]);
    return dimensions;
};

/**
 * `useInterval` is based on [Dan Abromov's blog](https://overreacted.io/making-setinterval-declarative-with-react-hooks/)
 * with additional ability to reset the interval
 * @param callback the callback you want to invoke for each interval
 * @param interval pass down `null` to pause the interval
 * @returns function to reset the current interval
 */
function useInterval(callback, interval) {
    const savedCallback = React.useRef(null);
    const [resetCount, setResetCount] = React.useState(0);
    // Remember the latest function.
    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    React.useEffect(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        if (interval !== null) {
            let id = setInterval(tick, interval);
            return () => clearInterval(id);
        }
        return;
    }, [interval, resetCount]);
    return function reset() {
        setResetCount((lastCount) => lastCount + 1);
    };
}

/**
 * `React.createContext` with the use case where the consumer must be rendered within
 * a provider.
 */
const createRequiredContext = ({ contextName, providerName = `${contextName}Provider`, }) => {
    const Context = createNamedContext(contextName, undefined);
    const useRequiredContext = (componentName) => {
        const cValue = React.useContext(Context);
        if (!isDefined(cValue)) {
            throw new Error(`${componentName} must be rendered within ${providerName}`);
        }
        return cValue;
    };
    return Object.assign(Context, {
        useRequiredContext,
    });
};

const IsClientContext = createRequiredContext({
    contextName: 'IsClientContext',
    providerName: 'IsClientProvider',
});
const IsClientProvider = (props) => {
    const [isClient, setIsClient] = React.useState(false);
    React.useEffect(() => {
        setIsClient(true);
    }, []);
    return (React.createElement(IsClientContext.Provider, { value: isClient }, props.children));
};
const useIsClient = IsClientContext.useRequiredContext;

const useRef = React.useRef;
const useIsInViewport = (options) => {
    const [, forceUpdate] = React.useState();
    const observer = useRef();
    const inViewportRef = useRef(isBoolean$1(options.initialInViewport) ? options.initialInViewport : false);
    const intersected = useRef(false);
    function startObserver(observerInstance) {
        const targetRef = options.target.current;
        if (targetRef) {
            observerInstance.observe(targetRef);
        }
    }
    function stopObserver(observerInstance) {
        const targetRef = options.target.current;
        if (targetRef) {
            observerInstance.unobserve(targetRef);
        }
        observerInstance.disconnect();
        observer.current = undefined;
    }
    function handleIntersection(entries) {
        const entry = entries[0] || {};
        const { isIntersecting, intersectionRatio } = entry;
        const isInViewport = typeof isIntersecting !== 'undefined'
            ? isIntersecting
            : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            if (options.disconnectOnEnter && observer.current) {
                stopObserver(observer.current);
            }
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            if (options.disconnectOnLeave && observer.current) {
                // disconnect obsever on leave
                observer.current.disconnect();
            }
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    }
    function initIntersectionObserver() {
        if (!observer.current) {
            // $FlowFixMe
            observer.current = new IntersectionObserver(handleIntersection, options.init);
            return observer.current;
        }
        return observer.current;
    }
    React.useEffect(() => {
        if (!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
            const { fallbackValueIfUnsupported: defaultValueIfUnsupported = true } = options;
            inViewportRef.current = defaultValueIfUnsupported;
            forceUpdate(defaultValueIfUnsupported);
            return;
        }
        const observerRef = initIntersectionObserver();
        startObserver(observerRef);
        return () => {
            stopObserver(observerRef);
        };
    }, [options.init, options.disconnectOnLeave]);
    return {
        inViewport: inViewportRef.current,
    };
};

/**
 * `useListState` declare an array state that allows you to append item that auto removed after some time.
 *
 * @param init initial value
 */
const useListState = (init = []) => {
    const [items, setItems] = React.useState(() => {
        const initValue = isFunction(init) ? init() : init;
        return initValue.map((value) => ({
            value,
            show: true,
            key: getId(),
        }));
    });
    const removeTimerMap = useConstant(() => new Map());
    const hideTimerMap = useConstant(() => new Map());
    React.useEffect(() => function cleanupTimers() {
        removeTimerMap.forEach((t) => window.clearTimeout(t));
        removeTimerMap.clear();
        hideTimerMap.forEach((t) => window.clearTimeout(t));
        hideTimerMap.clear();
    }, []);
    const cancelRemoveTimerIfExists = React.useCallback(function removeTimer(key) {
        const timer = hideTimerMap.get(key);
        if (isDefined(timer)) {
            window.clearTimeout(timer);
            hideTimerMap.delete(key);
        }
    }, [removeTimerMap]);
    const hideItem = useStableCallback(function hideItem(item) {
        setItems((prevItems) => prevItems.map((i) => i.key === item.key
            ? Object.assign(Object.assign({}, i), { show: false }) : i));
        cancelRemoveTimerIfExists(item.key);
    });
    const removeItem = useStableCallback(function removeItem(item) {
        setItems((prevItems) => prevItems.filter((i) => i.key !== item.key));
        cancelRemoveTimerIfExists(item.key);
    });
    const addItem = React.useCallback(function addItem(type, item, { removeAfterMs, hideAfterMs, } = {}) {
        const key = getId();
        const record = {
            value: item,
            show: true,
            key,
        };
        setItems((prevItems) => type === 'append'
            ? prevItems.concat(record)
            : [record].concat(prevItems));
        if (isNumber(removeAfterMs)) {
            cancelRemoveTimerIfExists(key);
            const timer = window.setTimeout(() => {
                removeItem(record);
            }, removeAfterMs);
            removeTimerMap.set(key, timer);
        }
        if (isNumber(hideAfterMs)) {
            const timer = window.setTimeout(() => {
                hideItem(record);
            }, hideAfterMs);
            hideTimerMap.set(key, timer);
        }
        return Object.assign(function removeFn() {
            removeItem(record);
        }, {
            hide: () => hideItem(record),
        });
    }, [removeTimerMap, hideItem, removeItem]);
    return {
        items: React.useMemo(() => items.map((item) => (Object.assign(Object.assign({}, item), { update: (updatedItem) => {
                setItems((prevItems) => prevItems.map((prevItem) => prevItem === item
                    ? Object.assign(Object.assign({}, prevItem), { value: updatedItem }) : prevItem));
            }, hide: (options = {}) => {
                hideItem(item);
                if (isNumber(options.removeAfterMs)) {
                    const timer = window.setTimeout(() => {
                        removeItem(item);
                    }, options.removeAfterMs);
                    removeTimerMap.set(item.key, timer);
                }
            }, remove: () => removeItem(item) }))), [items]),
        append: React.useMemo(() => addItem.bind(null, 'append'), [addItem]),
        prepend: React.useMemo(() => addItem.bind(null, 'prepend'), [addItem]),
        clear: useStableCallback(function clearItems() {
            removeTimerMap.forEach((t) => window.clearTimeout(t));
            removeTimerMap.clear();
            setItems([]);
        }),
    };
};

/**
 * Listen for pointer down and focus outside an element.
 *
 * This customer hook returns props to be spreaded to element.
 */
const useOnInteractOutside = (options) => {
    const pointerDownProps = usePointerDownOutside(options.onInteractOutside);
    const focusOutsideProps = useFocusOutside(options.onInteractOutside);
    return Object.assign(Object.assign({}, pointerDownProps), focusOutsideProps);
};
/* -------------------------------------------------------------------------------------------------
 * Utility hooks
 * -----------------------------------------------------------------------------------------------*/
const POINTER_DOWN_OUTSIDE = 'dismissableLayer.pointerDownOutside';
const FOCUS_OUTSIDE = 'dismissableLayer.focusOutside';
/**
 * Sets up `pointerdown` listener which listens for events outside a react subtree.
 *
 * We use `pointerdown` rather than `pointerup` to mimic layer dismissing behaviour
 * present in OS which usually happens on `pointerdown`.
 *
 * Returns props to pass to the node we want to check for outside events.
 */
function usePointerDownOutside(onPointerDownOutside) {
    const handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
    const isPointerInsideReactTreeRef = React.useRef(false);
    React.useEffect(() => {
        const handlePointerDown = (event) => {
            const target = event.target;
            if (target && !isPointerInsideReactTreeRef.current) {
                const pointerDownOutsideEvent = new CustomEvent(POINTER_DOWN_OUTSIDE, {
                    bubbles: false,
                    cancelable: true,
                    detail: { originalEvent: event },
                });
                target.addEventListener(POINTER_DOWN_OUTSIDE, handlePointerDownOutside, { once: true });
                target.dispatchEvent(pointerDownOutsideEvent);
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
         * if this hook executes in a component that mounts via a `pointerdown` event, the event
         * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
         * this by delaying the event listener registration on the document.
         * This is not React specific, but rather how the DOM works, ie:
         * ```
         * button.addEventListener('pointerdown', () => {
         *   console.log('I will log');
         *   document.addEventListener('pointerdown', () => {
         *     console.log('I will also log');
         *   })
         * });
         */
        const timerId = window.setTimeout(() => {
            document.addEventListener('pointerdown', handlePointerDown);
        }, 0);
        return () => {
            window.clearTimeout(timerId);
            document.removeEventListener('pointerdown', handlePointerDown);
        };
    }, [handlePointerDownOutside]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: () => (isPointerInsideReactTreeRef.current = true),
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */
function useFocusOutside(onFocusOutside) {
    const handleFocusOutside = useCallbackRef(onFocusOutside);
    const isFocusInsideReactTreeRef = React.useRef(false);
    React.useEffect(() => {
        const handleFocus = (event) => {
            const target = event.target;
            if (target && !isFocusInsideReactTreeRef.current) {
                const focusOutsideEvent = new CustomEvent(FOCUS_OUTSIDE, {
                    bubbles: false,
                    cancelable: true,
                    detail: { originalEvent: event },
                });
                target.addEventListener(FOCUS_OUTSIDE, handleFocusOutside, {
                    once: true,
                });
                target.dispatchEvent(focusOutsideEvent);
            }
        };
        document.addEventListener('focusin', handleFocus);
        return () => document.removeEventListener('focusin', handleFocus);
    }, [handleFocusOutside]);
    return {
        onFocusCapture: () => (isFocusInsideReactTreeRef.current = true),
        onBlurCapture: () => (isFocusInsideReactTreeRef.current = false),
    };
}

/**
 * @private
 */
const featureCheck = {
    stringRepeat: !!String.prototype.repeat,
    stringPadStart: !!String.prototype.padStart,
    stringPadEnd: !!String.prototype.padEnd,
    stringReplaceAll: !!String.prototype.replaceAll,
    get matchMedia() {
        return typeof window !== 'undefined' && !!window.matchMedia;
    },
    get otpCredential() {
        return typeof window !== 'undefined' && 'OTPCredential' in window;
    },
    intlNumberFormat: !!(Intl &&
        typeof Intl === 'object' &&
        typeof Intl.NumberFormat === 'function'),
    get intersectionObserver() {
        return typeof window !== 'undefined' && 'IntersectionObserver' in window;
    },
};

/**
 * Use Web OTP to get the one-time-password.
 *
 * @returns unsubscribe function, probably because user already fill up the OTP thus this is no longer required. You don't
 * need to call this manually if the component that renders this hooks will be unmount instantly when OTP is no longer needed.
 *
 * @see https://web.dev/web-otp/
 */
const useOtp = (options) => {
    const { onSuccess, enabled = true } = options;
    const unsubscribeRef = React.useRef(noop$1);
    const onSuccessCb = useStableCallback(onSuccess);
    React.useEffect(() => {
        if (enabled) {
            try {
                if (featureCheck.otpCredential) {
                    const ac = new AbortController();
                    navigator.credentials
                        .get({
                        otp: {
                            transport: ['sms'],
                        },
                        signal: ac.signal,
                    })
                        .then((otp) => {
                        if (otp && otp.code) {
                            onSuccessCb(otp.code);
                        }
                    })
                        .catch(noop$1);
                    unsubscribeRef.current = () => ac.abort();
                    return () => {
                        ac.abort();
                        unsubscribeRef.current = noop$1;
                    };
                }
            }
            catch (err) {
                // no handling as user can still manually copied form sms
            }
        }
    }, [enabled]);
    return function stopListenForOtp() {
        unsubscribeRef.current();
    };
};

const usePaginationState = ({ initialPage, initialPerPage, initialIsLastPage, onChange = noop$1, } = {}) => {
    const [state, setState] = React.useState(() => ({
        page: initialPage !== null && initialPage !== void 0 ? initialPage : 1,
        perPage: initialPerPage !== null && initialPerPage !== void 0 ? initialPerPage : 20,
        isLastPage: initialIsLastPage !== null && initialIsLastPage !== void 0 ? initialIsLastPage : false,
    }));
    const setPage = useStableCallback(function setPage(page) {
        const latestState = Object.assign(Object.assign({}, state), { page, isLastPage: false });
        setState(latestState);
        onChange(latestState);
    });
    const setPerPage = useStableCallback(function setPerPage(perPage) {
        const latestState = Object.assign(Object.assign({}, state), { page: 1, perPage });
        setState(latestState);
        onChange(latestState);
    });
    const setIsLastPage = useStableCallback(function setIsLastPage(isLastPage) {
        const latestState = Object.assign(Object.assign({}, state), { isLastPage });
        setState(latestState);
        onChange(latestState);
    });
    return React.useMemo(() => ({
        page: state.page,
        perPage: state.perPage,
        isLastPage: state.isLastPage,
        setPage,
        setPerPage,
        setIsLastPage,
    }), [state, setPage, setPerPage, setIsLastPage]);
};

/**
 * Similar to `React.useRef`, except that this is an array of ref instead of single ref.
 *
 * Note that the returned array with have its identity change whenever the length change.
 *
 * @param length the number of needed refs
 * @returns an array of refs with the provided length
 */
const useRefs = (length) => {
    const refs = React.useRef([]);
    if (refs.current.length !== length) {
        refs.current = createArray(length).map((_, index) => refs.current[index] || React.createRef());
    }
    return refs.current;
};

const useSortState = (defaultSortCriteria) => {
    const [state, dispatch] = React.useReducer(sortKeyReducer, defaultSortCriteria);
    return Object.assign(Object.assign({}, state), { sort: React.useCallback(({ sortBy, initialOrder = 'asc', }) => dispatch({
            type: 'sort',
            sortBy,
            initialOrder,
        }), []) });
};
const sortKeyReducer = (state, action) => {
    if (state.sortBy === action.sortBy) {
        return Object.assign(Object.assign({}, state), { order: state.order === 'asc' ? 'desc' : 'asc' });
    }
    else {
        return {
            sortBy: action.sortBy,
            order: action.initialOrder,
        };
    }
};

const splitClass = (className, prefixes) => {
    if (!className) {
        return {
            matched: '',
            rest: '',
        };
    }
    const regex = new RegExp(prefixes.map((prefix) => `^${prefix}`).join('|'));
    const matchedClasses = [];
    const restClasses = [];
    className.split(' ').forEach((cs) => {
        if (regex.test(cs)) {
            matchedClasses.push(cs);
        }
        else {
            restClasses.push(cs);
        }
    });
    return {
        matched: matchedClasses.join(' '),
        rest: restClasses.join(' '),
    };
};

/**
 * This is memoized version of `splitClass` utility.
 */
const useSplitClass = (className, prefixes) => React.useMemo(() => splitClass(className, prefixes), [className, prefixes]);

/**
 * A custom hooks that works almost like React.useState, with the
 * difference that it will goes back to its steady state after certain restoration time.
 *
 * @param steadyState the initial state as well as the target state that will be restored to
 * @param restorationTime time taken before the state goes back to steadyState (Default to 1500)
 */
const useTransientState = (steadyState, restorationTime = 1500) => {
    const [state, setState] = React.useState(steadyState);
    const [calledTimes, setCallTimes] = React.useState(0); // to retrigger effect to reset timeout
    const setTemporaryState = React.useCallback(function setTemporaryState(newValue) {
        setState(newValue);
        setCallTimes((t) => t + 1);
    }, []);
    React.useEffect(() => {
        if (state !== steadyState && restorationTime) {
            const timeoutId = setTimeout(() => setState(steadyState), restorationTime);
            return () => clearTimeout(timeoutId);
        }
        return;
    }, [state, steadyState, restorationTime, calledTimes]);
    return [state, setTemporaryState];
};

function noop() { }
function throttle(func, wait = 100, context = null) {
    let timer = null;
    return function throttledFunction(...args) {
        if (timer === null) {
            timer = window.setTimeout(() => {
                func.apply(context, args);
                timer = null;
            }, wait);
        }
    };
}
function callAll(...fns) {
    return function callAllFns() {
        const arg = arguments;
        fns.forEach((fn) => typeof fn === 'function' && fn.apply(null, arg));
    };
}

const createAjaxOperation = (exec, { selectError = (x) => x } = {}) => function ajaxOperation(input, { onComplete = noop, onError = noop, onProgress = noop, prevData, numOfTotalRequests, numOfCompletedRequests, }) {
    const source = axios.CancelToken.source();
    const token = source.token;
    const promise = exec(isFunction(input) ? input({ prevData }) : input, Object.assign(token, {
        updateProgress: onProgress,
        cancelToken: token,
        prevData,
        numOfTotalRequests,
        numOfCompletedRequests,
    }), onProgress);
    promise.then(onComplete).catch((err) => {
        if (!err || !axios.isCancel(err)) {
            onError(selectError(err));
        }
    });
    function cancel() {
        source.cancel();
    }
    return {
        cancel,
    };
};
const createUploadFileOperation = (getRequestConfig, { axios: axiosInstance = axios, getErrorMessage = () => undefined, selectResult = (res) => res.data, } = {}) => createAjaxOperation((file, cancelToken, updateProgress) => {
    const requestConfig = getRequestConfig(file);
    return axiosInstance(Object.assign(Object.assign({}, requestConfig), { cancelToken, onUploadProgress: callAll(requestConfig.onUploadProgress, (event) => updateProgress(event.loaded / event.total)) })).then((res) => selectResult(res, file));
}, { selectError: getErrorMessage });
const ApiClientContext = createNamedContext('Axios', axios);
const ApiClientProvider = ApiClientContext.Provider;
const useApiClient = () => React.useContext(ApiClientContext);

const createCDNUtils = (...args) => {
    const utils = createCDNUtils$1(...args);
    const { toCDNImageUrl } = utils;
    const nextImageCDNLoader = ({ src, width, quality, }) => {
        return toCDNImageUrl(src, { width, quality });
    };
    const Image = React.forwardRef(function Image(_a, ref) {
        var { src, cdnModifiers } = _a, props = __rest(_a, ["src", "cdnModifiers"]);
        return React.createElement("img", Object.assign({ ref: ref, src: toCDNImageUrl(src, cdnModifiers) }, props));
    });
    return Object.assign(Object.assign({}, utils), { 
        /**
         * Loader to transform to image CDN format, made to be used with `next/image` image component
         */
        nextImageCDNLoader,
        /**
         * Image component for conveniently passing to image CDN, use this for existing images in S3 buckets
         */
        Image });
};

/**
 * create a pub-sub event bus.
 */
const createEventBus = () => {
    const listeners = [];
    return {
        listen: (listener) => {
            listeners.push(listener);
            return function unsubscribe() {
                listeners.splice(listeners.indexOf(listener), 1);
            };
        },
        emit: (...args) => listeners.forEach((l) => l(...args)),
    };
};

/**
 * Create a Fill-Slot pair that allows you to render React elements in arbitrary subtree.
 *
 * Limitation: the Fill and Slot can only be rendered once only.
 *
 * ```jsx static
 * import { createFillSlot, TextInput } from '@setel/portal-ui'; // or `@setel/web-ui`.
 *
 * const { Fill, Slot } = createFillSlot();
 *
 * const Content = () => {
 *   const [value, setValue] = React.useState('');
 *
 *   return (
 *     <div>
 *       <h2>Content</h2>
 *       <TextInput value={value} onChangeValue={setValue} />
 *       <Fill>
 *         Content in another place.
 *         <p>{value}</p>
 *         <p>Pretty cool?</p>
 *       </Fill>
 *     </div>
 *   );
 * };
 *
 * const Sidebar = () => {
 *   return (
 *     <div className="text-right">
 *       <p>Sidebar</p>
 *       <Slot />
 *     </div>
 *   );
 * };
 *
 * const App = () => {
 *   return (
 *     <div className="grid grid-cols-3 gap-4">
 *       <div className="col-span-2">
 *         <Content />
 *       </div>
 *       <Sidebar />
 *     </div>
 *   );
 * };
 *
 * <App />;
 * ```
 */
function createFillSlot() {
    const ref = React.createRef();
    const eventBus = createEventBus();
    function Slot(props) {
        React.useEffect(() => {
            if (ref.current) {
                eventBus.emit();
            }
        }, []);
        return React.createElement("div", Object.assign({}, props, { ref: ref }));
    }
    function Fill(props) {
        const forceUpdate = useForceUpdate();
        React.useLayoutEffect(() => eventBus.listen(forceUpdate), [forceUpdate]);
        return ref.current ? createPortal(props.children, ref.current) : null;
    }
    return {
        Slot,
        Fill,
    };
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const lightFormatters = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
const formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const longFormatters$1 = longFormatters;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
const formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
const formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
const formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
const localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
const match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
const defaultLocale = locale;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

// @overview: Helpers to format data in desired format
// no point adding big mapping if we
// only support MYR now
const currencyMap = {
    MYR: 'RM',
};
const commaPositionRegex = /\B(?=(\d{3})+(?!\d))/g;
function insertThousandSeparator(number) {
    const numString = String(number);
    if (numString.includes('.')) {
        const [integer, decimal] = numString.split('.');
        return `${integer.replace(commaPositionRegex, ',')}.${decimal}`;
    }
    return numString.replace(commaPositionRegex, ',');
}
const numberFormatters = {};
/**
 *
 * @param value the number value that you wish to format
 * @param currency can be 'MYR'
 */
const formatMoney = (value, currencyOrOptions = '') => {
    if (!isDefined(value)) {
        return '';
    }
    const numValue = Number(value);
    const decimalPlaces = !isString(currencyOrOptions) && isDefined(currencyOrOptions.decimalPlaces)
        ? currencyOrOptions.decimalPlaces
        : 2;
    let displayValue = '';
    if (isNaN(numValue)) {
        return value;
    }
    if (featureCheck.intlNumberFormat) {
        if (!numberFormatters[decimalPlaces]) {
            numberFormatters[decimalPlaces] = new Intl.NumberFormat('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        }
        displayValue = numberFormatters[decimalPlaces].format(numValue);
    }
    else {
        displayValue = insertThousandSeparator(numValue.toFixed(decimalPlaces));
    }
    const currency = isString(currencyOrOptions)
        ? currencyOrOptions
        : currencyOrOptions.currency || '';
    const currencyDisplay = currencyMap[currency] || currency;
    return currencyDisplay ? `${currencyDisplay} ${displayValue}` : displayValue;
};
function formatFileSize(fileSizeInByte, { decimalPlaces = 0 } = {}) {
    if (fileSizeInByte > bytePerGb) {
        return `${formatMoney(fileSizeInByte / bytePerGb, { decimalPlaces })}GB`;
    }
    if (fileSizeInByte > bytePerMb) {
        return `${formatMoney(fileSizeInByte / bytePerMb, { decimalPlaces })}MB`;
    }
    if (fileSizeInByte > bytePerKb) {
        return `${formatMoney(fileSizeInByte / bytePerKb, { decimalPlaces })}KB`;
    }
    return `${formatMoney(fileSizeInByte, { decimalPlaces })}B`;
}
const bytePerKb = 1024;
const bytePerMb = 1024 * bytePerKb;
const bytePerGb = 1024 * bytePerMb;
/**
 *
 * @param value original string
 * @param options options to customize behavior. `hasUnderscore: true` will split the string whenever '_' character is encountered.
 * `hasWhitespace: true` will split the string whenever white space is encountered.
 */
const titleCase = (value, options) => {
    if (!value) {
        return value;
    }
    if (options) {
        if (options.hasWhitespace && /\s/.test(value)) {
            return value
                .split(/(\s+)/)
                .filter((part) => part.trim().length > 0)
                .map((x) => titleCase(x, options))
                .join(' ');
        }
        if (options.hasUnderscore && /_/.test(value)) {
            return value
                .split('_')
                .map((x) => titleCase(x, options))
                .join(' ');
        }
        if (options.hasDash && /\-/.test(value)) {
            return value
                .split('-')
                .map((x) => titleCase(x, options))
                .join(' ');
        }
    }
    return value[0].toUpperCase() + value.substring(1).toLowerCase();
};
const stringRepeat = (charToRepeat, count) => {
    if (featureCheck.stringRepeat) {
        return charToRepeat.repeat(count);
    }
    if (count < 0 || count === Infinity) {
        throw RangeError(`Repeat count must be between 0 and Infinity`);
    }
    let result = '';
    for (let index = 0; index < count; index++) {
        result += charToRepeat;
    }
    return result;
};
const padStart = (oriString, maxLength, fillString = ' ') => {
    if (featureCheck.stringPadStart) {
        return oriString.padStart(maxLength, fillString);
    }
    const requiredPadding = maxLength - oriString.length;
    if (requiredPadding <= 0) {
        return oriString;
    }
    return stringRepeat(fillString, requiredPadding) + oriString;
};
const padEnd = (oriString, maxLength, fillString = ' ') => {
    if (featureCheck.stringPadEnd) {
        return oriString.padEnd(maxLength, fillString);
    }
    const requiredPadding = maxLength - oriString.length;
    if (requiredPadding <= 0) {
        return oriString;
    }
    return oriString + stringRepeat(fillString, requiredPadding);
};
function escapeRegExp(string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
const replaceAll = (oriString, searchValue, replaceValue) => featureCheck.stringReplaceAll
    ? oriString.replaceAll(searchValue, replaceValue)
    : oriString.replace(new RegExp(escapeRegExp(searchValue), 'g'), replaceValue);
/**
 * small abstraction over `date-fns/format` function
 *
 * If the provided `date` is not a valid date, this function return it without modifying.
 *
 * @param date date value to be formatted
 * @param options
 * @param options.formatType convenient shorthand to specify the format, can be 'dateAndTime' or 'dateOnly'. Use to provide default for options.format
 * @param options.format format string that will be passed to second parameter of `date-fns/format`
 */
const formatDate = (date, { formatType = 'dateAndTime', format: format$1 = formatType === 'dateAndTime'
    ? FORMAT_STRING.dayAndTime
    : FORMAT_STRING.dayOnly, } = {}) => {
    if (formatType === 'monthOnly') {
        format$1 = FORMAT_STRING.monthOnly;
    }
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return isNaN(dateObj.getTime())
        ? date
        : format(dateObj, format$1);
};
/**
 * format a date range.
 *
 * @param from the earlier date. can be undefined.
 * @param to the later date. can be undefined or same as from.
 * @param dayOnly whether we only cares about date without considering time.
 */
const formatDateRange = (from, to, dayOnly) => {
    if (isDefined(from) && isDefined(to)) {
        if (isSameDay(from, to)) {
            const dayOnlyDisplay = formatDate(from, { formatType: 'dateOnly' });
            if (dayOnly) {
                return dayOnlyDisplay;
            }
            const fromTime = format(from, FORMAT_STRING.timeOnly);
            const toTime = format(to, FORMAT_STRING.timeOnly);
            if (fromTime === toTime) {
                return formatDate(from, { formatType: 'dateAndTime' });
            }
            return `${dayOnlyDisplay}, ${fromTime} - ${toTime}`;
        }
    }
    return [from, to]
        .filter(isDefined)
        .map((d) => formatDate(d, { formatType: dayOnly ? 'dateOnly' : 'dateAndTime' }))
        .join(' - ');
};
/**
 * format a month range.
 *
 * @param from the earlier month. can be undefined.
 * @param to the later month. can be undefined or same as from.
 */
const formatMonthRange = (from, to) => {
    if (isDefined(from) && isDefined(to)) {
        if (isSameMonth(from, to)) {
            const fromTime = format(from, FORMAT_STRING.monthOnly);
            const toTime = format(to, FORMAT_STRING.monthOnly);
            if (fromTime === toTime) {
                return fromTime;
            }
        }
    }
    return [from, to]
        .filter(isDefined)
        .map((d) => format(d, FORMAT_STRING.monthOnly))
        .join(' - ');
};
/**
 * format a date to UTC date format, e.g. `'2021-02-03T16:00:00.000Z'`.
 *
 * Confession: TBH I don't really understand those date formats, I just copy from https://github.com/date-fns/date-fns/issues/1401#issuecomment-578580199.
 *
 * @param date the date that you want to format
 */
const formatDateUtc = (date) => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return format(addMinutes(d, d.getTimezoneOffset()), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");
};
const FORMAT_STRING = {
    dayOnly: 'd MMM yyyy',
    dayAndTime: 'd MMM yyyy, h:mm a',
    timeOnly: 'h:mm a',
    monthOnly: 'MMM yyyy',
};

const regexMap = new Map();
/**
 * Check if a user provided className to have specific prefix, useful if you
 * want to avoid conflict of tailwind className
 *
 * @param className the className that is user provided
 * @param utilPrefixes the prefixes you wish to check, e.g. `w-`
 */
const hasUtilClass = (className, ...utilPrefixes) => {
    if (!className) {
        return false;
    }
    const cacheKey = utilPrefixes.join(',');
    const cachedRegex = regexMap.get(cacheKey);
    if (cachedRegex) {
        return cachedRegex.test(className);
    }
    const regexPattern = flattenArray(utilPrefixes.map((prefix) => [`^${prefix}`, `\\s${prefix}`])).join('|');
    const regex = new RegExp(regexPattern);
    regexMap.set(cacheKey, regex);
    return regex.test(className);
};

/**
 * lightweight query string parsing shamelessly
 * copied and tweaked from https://github.com/kawanet/qs-lite/blob/master/qs-lite.js
 */
function parseQueryString(input) {
    const obj = {};
    if (input) {
        const sanitizedInput = input[0] === '?' ? input.slice(1) : input;
        sanitizedInput.replace(/\+/g, ' ').split(/[&;]/).forEach(it);
    }
    return obj;
    function it(pair) {
        const len = pair.length;
        if (!len)
            return;
        let pos = pair.indexOf('=');
        if (pos < 0)
            pos = len;
        const key = decodeURIComponent(pair.substr(0, pos));
        const value = decodeURIComponent(pair.substr(pos + 1));
        const currentValue = obj[key];
        if (currentValue) {
            if (Array.isArray(currentValue)) {
                currentValue.push(value);
            }
            else {
                obj[key] = [currentValue, value];
            }
        }
        else {
            obj[key] = value;
        }
    }
}
const hasOwnProperty = Object.prototype.hasOwnProperty;
const stringifyQueryString = (params, preText = '?') => {
    if (!params) {
        return '';
    }
    const result = [];
    function collectPair(key, value) {
        result.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    for (const key in params) {
        if (hasOwnProperty.call(params, key)) {
            const value = params[key];
            if (isNumber(value) || value) {
                if (Array.isArray(value)) {
                    value.forEach((val) => collectPair(key, val));
                }
                else {
                    collectPair(key, value);
                }
            }
        }
    }
    return preText + result.join('&');
};

const isEmail = (value) => /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value);

/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */
function isBoolean(value) {
  return typeof value === "boolean";
}

const scrollIntoView = scrollIntoViewIfNeeded;
const boolOrBoolString = (value) => {
    return value === 'true' ? true : isBoolean(value) ? value : false;
};

export { AddImageIcon, AmexIcon, ApiClientProvider, ArrowLeftIcon, ArrowRightInCircleIcon, BadgeIcon, BankIcon, BellIcon, BigCheckIcon, BookIcon, BoxIcon, BrokenLinkIcon, BusinessIcon, CalendarIcon, CameraIcon, CardIcon, CardsIcon, CartIcon, CheckIcon, CheckInCircleIcon, CheckInCircleOutlineIcon, CheckedIcon, ChevronDoubleRightIcon, ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, CircleIcon, CircleMinusIcon, ClipboardIcon, ClockIcon, CogIcon, CompassIcon, ContactBookIcon, CookiesIcon, CopyIcon, CreditCardIcon, CrossIcon, CrossInCircleIcon, DesktopIcon, DiamondIcon, DocIcon, DocumentIcon, DotHorizontalIcon, DotVerticalIcon, Dots, DownloadIcon, EVChargingIcon, EditIcon, EngineIcon, ErrorIcon, ExclamationIcon, ExpandLessIcon, ExpandMoreIcon, ExternalIcon, EyeHideIcon, EyeShowIcon, FamilyIcon, FilledStarIcon, FilterIcon, FuelTankIcon, GasTankIcon, HeartIcon, HelpIcon, HistoryIcon, ImageIcon, InboxIcon, InfoIcon, InfoOutlineIcon, InviteIcon, IsClientProvider, LanguageIcon, LifebuoyIcon, LinkIcon, ListIcon, LocationIcon, LockIcon, LogoutIcon, LorryIcon, LoudspeakerIcon, MailIcon, MalaysiaFlagIcon, MapIcon, MastercardIcon, MembershipIcon, MenuIcon, MerchantIcon, MesraCardIcon, MessageIcon, MeterIcon, MiniAscendingIcon, MiniChevronDownIcon, MiniChevronRightIcon, MiniCloseIcon, MiniDescendingIcon, MiniUnsortedIcon, MinusIcon, MoreIcon, OrderIcon, PetronasGreenIcon, PetronasWhiteIcon, Phone1Icon, PhoneIcon, PlusIcon, PreviewIcon, PrinterIcon, PumpIcon, ReceiptIcon, ReloadIcon, ReplayIcon, RewardsIcon, ScanIcon, SearchIcon, SetelDefaultIcon, SetelIcon, SetelLightIcon, SetelShareIcon, SetelWalletIcon, SettlementsIcon, ShareIcon, ShoppingBagIcon, SingaporeFlagIcon, SmartPayDarkIcon, SmartPayLightIcon, SparklesIcon, SpinIcon, StarIcon, SyncIcon, ThaiFlagIcon, ToggleIcon, TopupIcon, TransmissionIcon, TrashIcon, UploadIcon, UserCircleIcon, UserIcon, VehicleIcon, VerifiedIcon, VideoIcon, VisaIcon, VoidSalesIcon, VoucherIcon, WalletIcon, WarningIcon, ZoomInIcon, arrayMove, boolOrBoolString, callAll, createAjaxOperation, createArray, createCDNUtils, createDescendantContext, createEventBus, createFillSlot, createIcon as createIconComponentFromSvgUrl, createRequiredContext, createUploadFileOperation, dedupeArray, featureCheck, findLastIndex, flattenArray, forEach, formatDate, formatDateRange, formatDateUtc, formatFileSize, formatMoney, formatMonthRange, getComputedStyle, getComputedStyles, getId, hasUtilClass, insertThousandSeparator, isDefined, isEmail, isEmptyObject, isEmptyValue, isNil, isPrimitive, isSimilarArray, noop, omit, padEnd, padStart, parseQueryString, pick, pickAndOmit, replaceAll, scrollIntoView, splitClass, stringifyQueryString, throttle, titleCase, toArray, useAjaxOperations, useApiClient, useCallbackRef, useControllableState, useDebounce, useDefaultSvgProps, useDelayedCallback, useDescendantState, useFileUploads, useImageDimensions, useImageFileDimensions, useInterval, useIsClient, useIsInViewport, useListState, useOnInteractOutside, useOtp, usePaginationState, useRefs, useSortState, useSplitClass, useTransientState, withDefaultSvgProps };
//# sourceMappingURL=web-utils.esm.js.map
